// =============================================================================
// AuthClient.ts — Fala com as rotas de login social do servidor.
// A tela de título decide o que mostrar com base no /api/me:
//   configured=false  -> servidor sem OAuth/banco (modo dev)
//   user=null         -> mostrar ENTRAR COM GOOGLE
//   user={...}        -> mostrar CONTINUAR COMO FULANO / SAIR DA CONTA
// =============================================================================

export interface AuthUser {
  name: string | null;
  email: string | null;
  picture: string | null;
}

export interface AuthState {
  configured: boolean;
  user: AuthUser | null;
}

export async function fetchAuthState(): Promise<AuthState> {
  try {
    const res = await fetch('/api/me');
    if (!res.ok) return { configured: false, user: null };
    const data = (await res.json()) as { configured?: boolean; user?: AuthUser | null };
    return { configured: Boolean(data.configured), user: data.user ?? null };
  } catch {
    // Servidor fora do ar? O overlay de conexão cuida disso; aqui é modo dev
    return { configured: false, user: null };
  }
}

export async function logout(): Promise<void> {
  try {
    await fetch('/auth/logout', { method: 'POST' });
  } catch { /* sem rede o cookie continua, mas a UI volta pro estado deslogado */ }
}

/** Início do fluxo OAuth: navegação plena (o Google redireciona de volta). */
export function loginWithGoogle(): void {
  window.location.href = '/auth/google';
}
